// extracted by mini-css-extract-plugin
module.exports = {"done":"DoneMessage_done__lxG6X","svg":"DoneMessage_svg__1DrCk","message":"DoneMessage_message__2vOc_"};